import Socials from "./Socials";


function HomeLeft() {
  return (
   <div className="HomeLeft">
    <p id="signature">Pradyut Fogla</p>
    <Socials />
   </div>
  );
}
export default HomeLeft;